const FNA_SUFFIX = '.fna.fbcdn.net';

const PUBLIC_INSTAGRAM_HOST = 'scontent.cdninstagram.com';
const PUBLIC_FACEBOOK_HOST = 'scontent.xx.fbcdn.net';

export function publicMetaCdnUrl<T extends string | null | undefined>(url: T): T {
  if (typeof url !== 'string' || url.trim() === '') return url;

  let hostname: string;
  try {
    hostname = new URL(url).hostname;
  } catch {
    return url;
  }

  const lower = hostname.toLowerCase();
  if (!lower.endsWith(FNA_SUFFIX)) return url;

  const target = lower.startsWith('instagram.')
    ? PUBLIC_INSTAGRAM_HOST
    : PUBLIC_FACEBOOK_HOST;

  const schemeEnd = url.indexOf('://');
  if (schemeEnd === -1) return url;
  const authorityStart = schemeEnd + 3;

  let authorityEnd = url.length;
  for (const terminator of ['/', '?', '#']) {
    const i = url.indexOf(terminator, authorityStart);
    if (i !== -1 && i < authorityEnd) authorityEnd = i;
  }

  const authority = url.slice(authorityStart, authorityEnd);
  const atSign = authority.lastIndexOf('@');
  const hostStart = authorityStart + (atSign === -1 ? 0 : atSign + 1);

  const hostAndPort = url.slice(hostStart, authorityEnd);
  const colon = hostAndPort.lastIndexOf(':');
  const hostEnd = colon === -1 ? authorityEnd : hostStart + colon;

  return (url.slice(0, hostStart) + target + url.slice(hostEnd)) as T;
}
